module.exports = __webpack_public_path__ + "static/montadrill_logo.5b9614f8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/montadrill_logo.gif
// module id = 491
// module chunks = 114276838955818